import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  ReIndexTradePartnerWorkOrder,
  ReIndexTradePartnerWorkOrderVariables,
} from '../../athena/types/ReIndexTradePartnerWorkOrder';

export const RE_INDEX_TRADE_PARTNER_WORK_ORDER = gql`
  mutation ReIndexTradePartnerWorkOrder($id: String) {
    indextrious {
      reIndexTradePartnerWorkOrder(
        input: { id: $id, index: TRADE_PARTNER_WORK_ORDER, sync: true }
      ) {
        _empty
      }
    }
  }
`;

const useReIndexWorkOrder = () => {
  return useMutation<ReIndexTradePartnerWorkOrder, ReIndexTradePartnerWorkOrderVariables>(
    RE_INDEX_TRADE_PARTNER_WORK_ORDER,
  );
};

export default useReIndexWorkOrder;
